<template>
  <a href="javascript:;" @click="$store.commit('searchMachines/setCategory', {'code':'low-emission','label': $t('low_emissions') })" class="bs-push push-oxygen"
     :class="brandBackgroundColor">
    <div class="bs-content">
      <img :src="require('@/assets/img/low-emission-oxygen.png')" class="img-target">

      <span class="subtitle">
        {{ $t("low_emissions_machines") }}
      </span>
    </div>
  </a>
</template>

<script>

export default {
  name: 'PushBestSeller',
}
</script>

<style lang="scss">
.bs-push.push-oxygen {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  //width: 200px;
  // height: var(--card-height)!important;

  padding: 0 25px;
  text-align: center;
  border-radius: 20px;
  box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
  order: 3;

  background: #00a0e4;
  background: radial-gradient(circle, #00a0e4 0%, #006994 80%);

  @media #{$mq_semilarge_desktop} {
    order: 2;
  }

  @media #{$mq_large_desktop} {
    order: 1;
  }

  .bs-content {
    padding-bottom: 25px;
  }

  .img-target {
    width: 140px;
    display: block;
    margin: 0 auto;

    @media #{$mq_phone} {
      width: 160px;
    }
  }

  @media #{$mq_tablet} {
    height: 225px;
  }

  @media #{$mq_phone} {
    height: 180px;
  }

  &:hover {
    background-color: $blackish;
  }

  &:after {
    @include icomoon;
    content: '\e90e';
    position: absolute;
    bottom: 16px;
    left: 0;
    right: 0;
    font-size: 20px;
    color: $white;

    @media #{$mq_tablet} {
      bottom: 20px;
    }

    @media #{$mq_phone} {
      display: none;
      bottom: 25px;
    }
  }

  .title {
    margin-top: 15px;
    @include medium-title($white);
  }

  .subtitle {
    opacity: 1;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 18px;
    color: $white;
  }

  .star-1 {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 26px;
  }

  .star-2 {
    position: absolute;
    top: 25px;
    right: 35px;
    font-size: 20px;
  }

  .star-3 {
    position: absolute;
    bottom: 25px;
    left: 10px;
    font-size: 26px;
  }
  .star-4 {
    position: absolute;
    bottom: 10px;
    left: 35px;
    font-size: 20px;
  }

}
</style>
